import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core';
import { ModalMenuUI } from '../../Modal/ModalMenuUI';
import Scrollbar from '../../Scrollbar/Scrollbar';
import { Typography } from '../../typography/Typography';
import { documentedShortCuts } from '../documentShortcut';
import { ShortCutKey } from './ShortCutKey';
import { ShortCut } from '../ShortCut';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    scrollbar: {
      height: '100%'
    },
    categorieWrapper: {
      display: 'grid',
      gridTemplateColumns: '0.8fr auto',
      gridTemplateRows: 'repeat(auto)',
      columnGap: 16,
      rowGap: 24,
      justifyItems: 'start',
      marginRight: 24
    },
    categorie: {
      gridColumn: '1/3',
      marginTop: 24
    }
  })
);

export const ShortCuts = ({ open, close }) => {
  const categories = Object.keys(documentedShortCuts);

  const classes = useStyles();

  return (
    <>
      <ShortCut
        keyCode="?"
        action={close}
        help="Show keyboard shortcuts"
        icon="guide"
      />
      {open && (
        <ModalMenuUI
          onCloseEvent={close}
          showCloseButton={true}
          title="Keyboard shortcuts"
          wide={true}
          multiplyContentSpace={8}
          defineMargins="allMargins"
        >
          <Scrollbar className={classes.scrollbar}>
            <div className={classes.categorieWrapper}>
              {categories.map((c) => {
                const keys = Object.keys(documentedShortCuts[c]);
                return (
                  <>
                    <div className={classes.categorie}>
                      <Typography variant="heading1">{c}</Typography>
                    </div>

                    {keys.map((k) => {
                      return (
                        <ShortCutKey
                          key={k}
                          keyCode={k}
                          help={documentedShortCuts[c][k].help}
                        />
                      );
                    })}
                  </>
                );
              })}
            </div>
          </Scrollbar>
        </ModalMenuUI>
      )}
    </>
  );
};

export default ShortCuts;
